import { addMonths, format, startOfMonth } from 'date-fns';
import { formatDateISO } from '../../../helpers/format-date';

type Props = {
  value: Date | null;
  onChange: (date: Date | null) => void;
};

export function DisabledUntilPicker({ value, onChange }: Props) {
  const now = new Date();
  const months = Array.from({ length: 12 }, (_, i) => {
    const date = startOfMonth(addMonths(now, i + 1));

    return { label: format(date, 'MMM'), date };
  });

  const selectedMonthStr = value ? format(startOfMonth(value), 'yyyy-MM') : null;

  return (
    <div className="flex flex-col gap-3">
      <button
        type="button"
        onClick={() => onChange(null)}
        className={`self-start rounded-md px-2.5 py-1 text-xs font-medium transition-colors ${
          value === null
            ? 'bg-primary-600 text-white'
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }`}
      >
        Indefinitely
      </button>

      <div className="grid grid-cols-6 gap-1.5">
        {months.map((m) => (
          <button
            key={format(m.date, 'yyyy-MM')}
            type="button"
            onClick={() => onChange(m.date)}
            className={`rounded-md px-2.5 py-1 text-xs font-medium transition-colors ${
              selectedMonthStr === format(m.date, 'yyyy-MM')
                ? 'bg-primary-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {m.label}
          </button>
        ))}
      </div>

      <div className="flex flex-col gap-1">
        <span className="text-xs font-medium text-gray-700">Specific date</span>
        <input
          type="date"
          value={value ? formatDateISO(value) : ''}
          min={formatDateISO(now)}
          onChange={(e) => {
            if (e.target.value) {
              onChange(new Date(`${e.target.value}T00:00:00`));
            }
          }}
          className="block w-full rounded-md border-gray-300 text-sm shadow-sm focus:border-primary-500 focus:ring-primary-500"
        />
      </div>
    </div>
  );
}
